import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { TextField } from 'redux-form-material-ui';
import loadNote from 'reducers/landlordTenantsReducer';
import { connect } from 'react-redux';

import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';

let LeaseNotesForm = props => {
  const { handleSubmit } = props;

  return (
    <div>
      <form onSubmit={handleSubmit.bind(this)} id="form_field">
        <div style={{ textAlign: 'center', fontSize: '14px' }}>
          Only your company will have access to these notes (<TenantResidentVerbiageHelper />s will
          not see these.)
        </div>

        <div className="row">
          <div className="col-xs-12" style={{ textAlign: 'center' }}>
            <div style={{ margin: 'auto', textAlign: 'initial' }}>
              <Field
                name="notes"
                component={TextField}
                style={{ fontSize: '14px' }}
                floatingLabelText="Lease Notes"
                fullWidth
                multiLine={true}
                rows={2}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

LeaseNotesForm = reduxForm({
  form: 'lease_note_form', // a unique identifier for this form
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(LeaseNotesForm);

LeaseNotesForm = connect(
  state => ({
    initialValues: { notes: state.landlordTenants.lease_note }, // pull initial values from account reducer
  }),
  { load: loadNote }
)(LeaseNotesForm);

export default LeaseNotesForm;
